module.exports = __webpack_public_path__ + "img/what-happens-mobile.188d5163.webp";